import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var ArchiveIcon24Regular = forwardRefAndName('ArchiveIcon24Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 24
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M10.75 4.5C10.3358 4.5 10 4.83579 10 5.25C10 5.66421 10.3358 6 10.75 6H12.25C12.6642 6 13 5.66421 13 5.25C13 4.83579 12.6642 4.5 12.25 4.5H10.75Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M8 6.75C8 6.33579 8.33579 6 8.75 6H10.25C10.6642 6 11 6.33579 11 6.75C11 7.16421 10.6642 7.5 10.25 7.5H8.75C8.33579 7.5 8 7.16421 8 6.75Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M10.75 7.5C10.3358 7.5 10 7.83579 10 8.25C10 8.66421 10.3358 9 10.75 9H12.25C12.6642 9 13 8.66421 13 8.25C13 7.83579 12.6642 7.5 12.25 7.5H10.75Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M8 9.75C8 9.33579 8.33579 9 8.75 9H10.25C10.6642 9 11 9.33579 11 9.75C11 10.1642 10.6642 10.5 10.25 10.5H8.75C8.33579 10.5 8 10.1642 8 9.75Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.4444 15.3301C13.4444 16.7098 12.2188 18 10.7153 18C9.21191 18 8 16.7098 8 15.3301C8 14.3128 8.86715 12.4416 9.32271 11.5288C9.48672 11.2001 9.82394 11 10.1912 11H11.2049C11.5903 11 11.941 11.2205 12.1005 11.5713C12.5572 12.5752 13.4444 14.6173 13.4444 15.3301ZM11.986 15.3749C11.986 16.0729 11.4202 16.6388 10.7221 16.6388C10.0241 16.6388 9.45825 16.0729 9.45825 15.3749C9.45825 14.6769 10.0241 14.111 10.7221 14.111C11.4202 14.111 11.986 14.6769 11.986 15.3749Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.25 6C4.25 3.92893 5.92893 2.25 8 2.25H16C18.0711 2.25 19.75 3.92893 19.75 6V18C19.75 20.0711 18.0711 21.75 16 21.75H8C5.92893 21.75 4.25 20.0711 4.25 18V6ZM8 3.75C6.75736 3.75 5.75 4.75736 5.75 6V18C5.75 19.2426 6.75736 20.25 8 20.25H16C17.2426 20.25 18.25 19.2426 18.25 18V6C18.25 4.75736 17.2426 3.75 16 3.75H11C11 4.16421 10.6642 4.5 10.25 4.5H8.75C8.33579 4.5 8 4.16421 8 3.75Z"
    }))
  );
});